import { setPresetDraftState } from 'components/Graph/helpers/setPresetDraftState';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface DeleteTopologyPresetCommand {
  id: string;
}

export const deleteTopologyPreset: GraphCommandFactory<
  DeleteTopologyPresetCommand
> = (cmdContext) => async (command) => {
  try {
    cmdContext.updateState(setPresetDraftState('deleting'));
    await cmdContext.api.request({
      url: `/graphs/presets/${encodeURIComponent(command.id)}`,
      method: 'DELETE',
    });
    cmdContext.updateState((draft) => {
      draft.layoutSettings.presets = draft.layoutSettings.presets.filter(
        (preset) => preset.id !== command.id,
      );
      // Fixed noUncheckedIndexedAccess NIM-19408
      draft.layoutSettings.presetDraft = draft.layoutSettings.presets[0]!;
      draft.layoutSettings.presetDraftState = 'idle';
      draft.layoutSettings.presetEditMode = false;
    });
    cmdContext.showNotification({
      type: 'success',
      message: cmdContext.msg.canvasGraph.request.presetDeleted,
    });
  } finally {
    cmdContext.updateState(setPresetDraftState('idle'));
  }
};
